import { render, staticRenderFns } from "./FiltersCategoriesRow.vue?vue&type=template&id=01012b29&"
import script from "./FiltersCategoriesRow.vue?vue&type=script&lang=js&"
export * from "./FiltersCategoriesRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports